var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCustomerAddpoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "ca52c392-5e68-4058-955c-0c830e170197"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "643518e7-bb02-45fa-bec7-39d68c45fe8d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.42 0 0 4.42 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(85,85,85)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-200.27, -211.62)",
    d: "M 272.81 120.95 L 127.73 120.95 C 117.72 120.96000000000001 109.61 129.07 109.60000000000001 139.08 L 109.60000000000001 159.23000000000002 C 109.60000000000001 166.15 111.71000000000001 172.9 115.64000000000001 178.59000000000003 L 115.64000000000001 284.15000000000003 C 115.65000000000002 294.16 123.76000000000002 302.27000000000004 133.77 302.28000000000003 L 266.76 302.28000000000003 C 276.77 302.27000000000004 284.88 294.16 284.89 284.15000000000003 L 284.89 178.59000000000003 C 288.83 172.90000000000003 290.94 166.15000000000003 290.93 159.23000000000002 L 290.93 139.08 C 290.92 129.07000000000002 282.81 120.96000000000001 272.8 120.95000000000002 Z M 278.85 139.08 L 278.85 159.23000000000002 C 278.76000000000005 171.47000000000003 268.76000000000005 181.32000000000002 256.52000000000004 181.23000000000002 C 244.41000000000003 181.14000000000001 234.61000000000004 171.34000000000003 234.52000000000004 159.23000000000002 L 234.52000000000004 133.03000000000003 L 272.80000000000007 133.03000000000003 C 276.14000000000004 133.03000000000003 278.8400000000001 135.74000000000004 278.8400000000001 139.07000000000002 Z M 222.44 159.24 C 222.44 171.48000000000002 212.51 181.4 200.26 181.4 C 188.01999999999998 181.4 178.10999999999999 171.48000000000002 178.1 159.24 L 178.1 133.04000000000002 L 222.43 133.04000000000002 L 222.43 159.24 Z M 121.69 139.08 C 121.69 135.74 124.39999999999999 133.04000000000002 127.73 133.04000000000002 L 166.01 133.04000000000002 L 166.01 159.24 C 165.92 171.48000000000002 155.92 181.33 143.68 181.24 C 131.57 181.15 121.77000000000001 171.35000000000002 121.68 159.24 L 121.68 139.09 Z M 266.76 290.2 L 133.76999999999998 290.2 C 130.42999999999998 290.2 127.72999999999998 287.49 127.72999999999998 284.15999999999997 L 127.72999999999998 189.26999999999998 C 132.67 191.99999999999997 138.20999999999998 193.45 143.84999999999997 193.48999999999998 C 155.12999999999997 193.48999999999998 165.67999999999995 187.90999999999997 172.05999999999997 178.59999999999997 C 182.70999999999998 194.17999999999998 203.97999999999996 198.17999999999995 219.55999999999997 187.51999999999995 C 223.05999999999997 185.12999999999997 226.08999999999997 182.09999999999997 228.47999999999996 178.59999999999997 C 234.84999999999997 187.90999999999997 245.39999999999998 193.47999999999996 256.68999999999994 193.48999999999995 C 262.3299999999999 193.44999999999996 267.86999999999995 191.99999999999994 272.80999999999995 189.26999999999995 L 272.80999999999995 284.15999999999997 C 272.80999999999995 287.49999999999994 270.09999999999997 290.2 266.7699999999999 290.2 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -30.76 47.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(85,85,85)",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-169.51, -259.46)",
    d: "M 158.98 261.59 L 158.98 246.85999999999999 C 158.98 243.82999999999998 161.44 241.36999999999998 164.47 241.36999999999998 L 174.55 241.36999999999998 C 177.58 241.36999999999998 180.04000000000002 243.82999999999998 180.04000000000002 246.85999999999999 L 180.04000000000002 272.07 C 180.04000000000002 275.09999999999997 177.58 277.56 174.55 277.56 L 164.47 277.56 C 161.44 277.56 158.98 275.1 158.98 272.07 L 158.98 267.55",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 28.43 -8.33)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(85,85,85)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-228.7, -203.29)",
    d: "M 232.4 199.59 C 231.1 198.29 229 198.29 227.70000000000002 199.59 L 225.00000000000003 202.29 C 223.70000000000002 203.59 223.70000000000002 205.69 225.00000000000003 206.98999999999998 C 226.30000000000004 208.29 228.40000000000003 208.29 229.70000000000002 206.98999999999998 L 232.4 204.29 C 233.70000000000002 202.98999999999998 233.70000000000002 200.89 232.4 199.59 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10.47 51.76)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(85,85,85)",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-210.73, -263.38)",
    d: "M 179.9 273.25 C 181.24 273.4 182.69 273.46 184.28 273.42 C 185.41 273.40000000000003 186.51 273.7 187.49 274.26 C 191.18 276.39 195.93 277.71999999999997 200.53 278.53999999999996 C 205.49 279.41999999999996 210.26 279.68999999999994 213.32 279.68999999999994 C 218.03 279.68999999999994 223.87 276.59999999999997 229.51999999999998 272.36999999999995 C 233.2 269.61999999999995 236.79999999999998 266.37999999999994 239.93999999999997 263.2099999999999 C 242.10999999999996 261.0199999999999 242.10999999999996 257.4799999999999 239.92999999999998 255.29999999999993 L 239.92999999999998 255.29999999999993 C 237.86999999999998 253.23999999999992 234.77999999999997 252.60999999999993 232.07999999999998 253.67999999999992 C 229.7 254.61999999999992 226.82999999999998 255.78999999999994 223.89 257.06999999999994 C 220.63 258.47999999999996 217.29 260.0299999999999 214.45999999999998 261.54999999999995 C 215.12999999999997 260.65 215.60999999999999 259.59 215.80999999999997 258.4 C 216.47999999999996 254.43999999999997 213.81999999999996 250.68999999999997 209.85999999999999 250.01 C 207.24999999999997 249.57 203.42999999999998 249.20999999999998 199.05999999999997 249.20999999999998 C 197.57999999999998 249.20999999999998 196.03999999999996 249.24999999999997 194.46999999999997 249.33999999999997 C 193.92999999999998 249.36999999999998 193.37999999999997 249.31999999999996 192.84999999999997 249.17999999999998 C 189.22999999999996 248.26 184.04999999999995 247.46999999999997 180.01999999999995 247.06999999999996",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.5 51.39)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(85,85,85)",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-202.76, -263.01)",
    d: "M 214.46 261.55 C 213.29000000000002 262.8 211.18 263.93 209.35 264.11 C 206.76999999999998 264.36 204.23999999999998 264.47 201.87 264.47 C 197.5 264.47 193.68 264.12 191.07 263.67",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 21.76 37.71)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(85,85,85)",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-222.03, -249.33)",
    d: "M 232.07 253.69 C 233.19 251.57999999999998 232.87 248.91 231.10999999999999 247.13 L 231.10999999999999 247.13 C 229.05999999999997 245.06 225.98 244.4 223.26999999999998 245.46 C 221.26 246.24 218.89999999999998 247.18 216.43999999999997 248.21 C 214.74999999999997 248.92000000000002 213.01999999999998 249.66 211.32999999999996 250.43",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1.13 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(81,81,81)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-201.4, -210.12)",
    d: "M 202.93 203.73 L 199.86 216.5",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.53 5.09)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(85,85,85)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-202.8, -216.7)",
    d: "M 221.8 209.04 C 220.87 208.09 219.65 207.45999999999998 218.33 207.26999999999998 L 218.33 207.26999999999998 L 211.33 206.18999999999997 L 208.25 199.94999999999996 C 206.5 196.93999999999997 202.65 195.91999999999996 199.64 197.66999999999996 C 198.7 198.21999999999997 197.91 198.99999999999997 197.35999999999999 199.94999999999996 L 194.16 206.26999999999995 L 187.27 207.26999999999995 C 183.95000000000002 207.75999999999996 181.65 210.83999999999995 182.14000000000001 214.15999999999994 C 182.33 215.47999999999993 182.95000000000002 216.69999999999993 183.91000000000003 217.62999999999994 L 188.94000000000003 222.61999999999995 L 187.76000000000002 229.47999999999996 C 187.18 232.77999999999997 189.39000000000001 235.91999999999996 192.68 236.49999999999997 C 194.01000000000002 236.72999999999996 195.38 236.51999999999998 196.57 235.87999999999997 L 202.87 232.63999999999996 L 209.03 235.87999999999997 C 212 237.43999999999997 215.67 236.30999999999997 217.23 233.33999999999997 C 217.85 232.15999999999997 218.07 230.79999999999998 217.84 229.47999999999996 L 216.71 222.48999999999995 L 221.69 217.62999999999994 C 224.09 215.28999999999994 224.14 211.43999999999994 221.79 209.02999999999994 Z M 212.59 218.24 C 211.15 219.63 210.49 221.65 210.83 223.62 L 211.79000000000002 230.64000000000001 L 205.62000000000003 227.4 C 203.85000000000002 226.48000000000002 201.74000000000004 226.48000000000002 199.97000000000003 227.4 L 193.59000000000003 230.48000000000002 L 194.77000000000004 223.62 C 195.11000000000004 221.65 194.46000000000004 219.64000000000001 193.02000000000004 218.24 L 188.12000000000003 213.13 L 195.00000000000003 212.13 C 196.98000000000002 211.85 198.69000000000003 210.60999999999999 199.58000000000004 208.81 L 202.80000000000004 202.48 C 202.86000000000004 202.47 202.92000000000004 202.51 202.94000000000003 202.57 L 206.02000000000004 208.81 C 206.91000000000003 210.6 208.61000000000004 211.84 210.59000000000003 212.13 L 217.56000000000003 213.38 L 212.58000000000004 218.23 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.5 5.55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(85,85,85)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-200.76, -217.17)",
    d: "M 197.28 206.46 L 196.58 209.56 C 195.71 211.93 196.39000000000001 211.8 198.61 209.17000000000002 C 199.29000000000002 209.29000000000002 199.14000000000001 209.25000000000003 198.14000000000001 209.07000000000002 C 197.45000000000002 208.93000000000004 196.76000000000002 208.78000000000003 196.08 208.62000000000003 C 193.45000000000002 208.04000000000002 190.83 207.35000000000002 188.13000000000002 207.13000000000002 C 183.84000000000003 206.79000000000002 180.31000000000003 212.59000000000003 182.95000000000002 216.16000000000003 C 184.45000000000002 218.19000000000003 186.19000000000003 219.36 188.41000000000003 220.47000000000003 C 189.38000000000002 220.95000000000002 190.41000000000003 221.52000000000004 191.42000000000002 221.92000000000002 C 191.98000000000002 222.19000000000003 192.53000000000003 222.48000000000002 193.06 222.79000000000002 C 192.11 220.3 191.36 220.06000000000003 190.83 222.06000000000003 C 188.29000000000002 226.90000000000003 193.86 234.09000000000003 199.04000000000002 230.27000000000004 C 200.92000000000002 228.89000000000004 202.72000000000003 227.28000000000003 204.85000000000002 226.33000000000004 L 200.23000000000002 226.93000000000004 C 197.03000000000003 225.82000000000002 200.9 227.87000000000003 201.85000000000002 228.59000000000003 C 203.26000000000002 229.66000000000003 204.71000000000004 230.58000000000004 206.27 231.42000000000004 C 210.91 233.93000000000004 216.35000000000002 229.79000000000005 215.08 224.64000000000004 C 214.74 223.27000000000004 214.5 221.94000000000005 214.46 220.52000000000004 C 214.43 220.00000000000003 214.44 219.48000000000005 214.49 218.96000000000004 C 214.8 217.53000000000003 213.98000000000002 217.55000000000004 212.03 219.00000000000003 C 219.51 220.93000000000004 222.71 209.36 215.22 207.43000000000004 C 202.67 204.20000000000005 201.43 219.36000000000004 203.51 227.83000000000004 L 212.32 221.05000000000004 C 209.4 219.47000000000003 206.97 216.42000000000004 203.79 215.48000000000005 C 199.53 214.21000000000004 196.14 217.57000000000005 192.98 219.90000000000003 L 201.19 228.11000000000004 C 203.54 223.63000000000005 205.02 218.03000000000003 201.07 213.90000000000003 C 199.95 212.74000000000004 198.4 212.03000000000003 196.98 211.32000000000002 C 196.14999999999998 210.91000000000003 195.29 210.53000000000003 194.45999999999998 210.11 C 193.7 209.73000000000002 191.82 208.10000000000002 193.30999999999997 210.11 C 191.57999999999998 213.12 189.85999999999999 216.13000000000002 188.12999999999997 219.14000000000001 C 186.91999999999996 219.04000000000002 189.34999999999997 219.4 189.58999999999997 219.45000000000002 C 190.68999999999997 219.69000000000003 191.78999999999996 219.95000000000002 192.89 220.19000000000003 C 194.75 220.60000000000002 196.7 221.13000000000002 198.60999999999999 221.17000000000002 C 205.98999999999998 221.34 207.51999999999998 215.52 208.83999999999997 209.65 C 210.52999999999997 202.13 198.96999999999997 198.92000000000002 197.26999999999998 206.46 L 197.26999999999998 206.46 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -23.37 -8.33)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(85,85,85)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-176.9, -203.29)",
    d: "M 180.6 202.29 L 177.9 199.59 C 176.6 198.29 174.5 198.29 173.20000000000002 199.59 C 171.90000000000003 200.89000000000001 171.9 202.99 173.20000000000002 204.29 L 175.9 206.98999999999998 C 177.20000000000002 208.29 179.3 208.29 180.6 206.98999999999998 C 181.9 205.68999999999997 181.9 203.58999999999997 180.6 202.29 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 31.47 17.22)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(85,85,85)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-231.74, -228.84)",
    d: "M 234.78 225.52 L 228.69 225.52 C 226.85 225.52 225.37 227.01000000000002 225.37 228.84 C 225.37 230.67 226.86 232.16 228.69 232.16 L 234.78 232.16 C 236.62 232.16 238.1 230.67 238.1 228.84 C 238.1 227.01000000000002 236.60999999999999 225.52 234.78 225.52 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -26.41 17.22)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(85,85,85)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-173.86, -228.84)",
    d: "M 176.9 225.52 L 170.81 225.52 C 168.97 225.52 167.49 227.01000000000002 167.49 228.84 C 167.49 230.67 168.98000000000002 232.16 170.81 232.16 L 176.9 232.16 C 178.74 232.16 180.22 230.67 180.22 228.84 C 180.22 227.01000000000002 178.73 225.52 176.9 225.52 Z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCustomerAddpoint);
export default __webpack_public_path__ + "static/media/ic_customer_addpoint.34e3bb2772b90b9de5ff642fecd4b408.svg";
export { ForwardRef as ReactComponent };